import { render } from "./CheckboxTypeComponent.vue?vue&type=template&id=ef9860e2&scoped=true"
import script from "./CheckboxTypeComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxTypeComponent.vue?vue&type=script&lang=js"

import "./CheckboxTypeComponent.vue?vue&type=style&index=0&id=ef9860e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef9860e2"]])

export default __exports__